export default __webpack_public_path__ + "static/media/Collections-Logo__Bored-Ape.d2fb1c56.png";